import { render, staticRenderFns } from "./AppointmentNeeded.vue?vue&type=template&id=9c5fed50&"
import script from "./AppointmentNeeded.vue?vue&type=script&lang=js&"
export * from "./AppointmentNeeded.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentNeeded.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports